import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'app';

  constructor(
    private router: Router,
  ) { }

  shouldShowNav(): boolean {
    return !this.router.url.startsWith('/login')
        && !this.router.url.startsWith('/reset-password')
        && !this.router.url.startsWith('/forgot-password');
  }

}
